module.exports = __webpack_public_path__ + "img/bussines--icon.6b723a05.svg";